module.exports = __webpack_public_path__ + "files/b02780e5597b486e472c0f1ce60cd2fd.png";